import React from 'react';

const LockIcon = ({ size = 14, rotate = 'down', color='#787377' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.838 6.9005V5.838C13.838 3.543 13.2855 0.5 8.5 0.5C3.7145 0.5 3.162 3.543 3.162 5.838V6.9005C0.782 7.198 0 8.405 0 11.3715V12.9525C0 16.4375 1.0625 17.5 4.5475 17.5H12.4525C15.9375 17.5 17 16.4375 17 12.9525V11.3715C17 8.405 16.218 7.198 13.838 6.9005ZM8.5 14.729C7.0805 14.729 5.933 13.573 5.933 12.162C5.933 10.7425 7.089 9.595 8.5 9.595C9.911 9.595 11.067 10.751 11.067 12.162C11.067 13.5815 9.9195 14.729 8.5 14.729ZM4.5475 6.824C4.4795 6.824 4.42 6.824 4.352 6.824V5.838C4.352 3.3475 5.0575 1.69 8.5 1.69C11.9425 1.69 12.648 3.3475 12.648 5.838V6.8325C12.58 6.8325 12.5205 6.8325 12.4525 6.8325H4.5475V6.824Z"
        fill={color}
      />
    </svg>
  );
};

export default LockIcon;
